// @flow
export const TREE = 'commentsModule'
export const TABLE_BRANCH = 'table'
export const OPERATIONS_BRANCH = 'operations'

// Operations
export const ADD_COMMENT = '@commentsModule/ADD_COMMENT'
export const DELETE_COMMENTS = '@commentsModule/DELETE_COMMENTS'

// Routes
export const COMMENTS_ROUTE = '/comments'
export const RECOMMENDED_RATES_ROUTE = '/recommendedRates'
